<template>
  <div id="billing-base" class="flex">
    <div class="flex flex-col flex-grow">
      <div
        id="billing-header"
        class="sticky top-18 left-0 z-50 h-18 px-6 flex items-center flex-shrink-0 bg-pure-white"
        :style="{ width: 'calc(100vw - 0.5rem)' }"
      >
        <div class="flex items-center gap-2">
          <BlTextTitle3 text="Billing" />
        </div>
      </div>

      <div v-if="pageLoading" class="w-full h-128 grid place-items-center">
        <div class="blum-loader"></div>
      </div>
      <div v-else class="flex flex-col flex-grow">
        <div
          id="billing-details"
          class="sticky top-36 left-0 z-50 pb-4 px-6 flex gap-4 flex-shrink-0 bg-pure-white"
          :style="{ width: 'calc(100vw - 0.5rem)' }"
        >
          <div class="w-full flex flex-col gap-1">
            <BlTextBody2 text="Your team plan:" class="text-light-purple-400" />
            <div
              class="font-bold text-dark-purple-100"
              :style="{ fontSize: '1.375rem' }"
            >
              {{
                currentSubscription
                  ? subscriptionTypes[currentSubscription.type]
                  : "-"
              }}
            </div>
          </div>
          <div
            class="h-full w-0.5 flex-shrink-0"
            :style="{
              background:
                'linear-gradient(180deg, #FFFFFF 0%, #E6DBF3 50%, #FFFFFF 100%)'
            }"
          ></div>
          <div class="w-full flex flex-col gap-1">
            <BlTextBody2
              text="Next billing date:"
              class="text-light-purple-400"
            />
            <div
              class="font-bold text-dark-purple-100"
              :style="{ fontSize: '1.375rem' }"
            >
              {{
                displayDate({
                  date:
                    currentSubscription &&
                    currentSubscription.next_billing_date,
                  format: "DD MMMM YYYY"
                })
              }}
            </div>
          </div>
          <div
            class="h-full w-0.5 flex-shrink-0"
            :style="{
              background:
                'linear-gradient(180deg, #FFFFFF 0%, #E6DBF3 50%, #FFFFFF 100%)'
            }"
          ></div>
          <div class="w-full flex flex-col gap-1">
            <BlTextBody2
              text="Estimated annual bill:"
              class="text-light-purple-400"
            />
            <div v-if="!currentSubscription" class="flex gap-1">
              <div
                class="font-bold text-dark-purple-100 text"
                :style="{ fontSize: '1.375rem' }"
              >
                -
              </div>
            </div>
            <div v-else class="flex gap-1">
              <BlTextSubtitle2
                :text="currentSubscription.currency_sym"
                class="text-light-purple-200"
              />
              <div
                class="font-bold text-dark-purple-100 text"
                :style="{ fontSize: '1.375rem' }"
              >
                {{ priceFormats(currentSubscription.amount) }}
              </div>
            </div>
          </div>
          <div
            class="h-full w-0.5 flex-shrink-0"
            :style="{
              background:
                'linear-gradient(180deg, #FFFFFF 0%, #E6DBF3 50%, #FFFFFF 100%)'
            }"
          ></div>
          <div class="w-full flex flex-col gap-1">
            <BlTextBody2
              text="Number of team members:"
              class="text-light-purple-400"
            />
            <div
              class="font-bold text-dark-purple-100 text"
              :style="{ fontSize: '1.375rem' }"
            >
              {{ currentCenter.total_active_members }}
            </div>
            <router-link to="/team">
              <BlInputButton
                type="outlined"
                dense
                label="Manage team"
                class="w-full"
              />
            </router-link>
          </div>
        </div>

        <div
          id="billing-body"
          class="h-100 w-full grid place-items-center text-center"
        >
          <BlTextBody2
            text="Exciting updates ahead: Your billing history and invoices will appear here soon!"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { displayDate, displayPrice } from "@/plugins/helper.js";

import BlTextTitle3 from "../BlTextTitle3.vue";
import BlTextSubtitle2 from "../BlTextSubtitle2.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlInputButton from "../BlInputButton.vue";

export default {
  name: "Billing",
  components: { BlTextTitle3, BlTextSubtitle2, BlTextBody2, BlInputButton },
  data() {
    return {
      pageLoading: true,
      subscriptionTypes: {
        "Subscription::Custom": "Custom",
        "Subscription::FreeTrial": "Free trial"
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter", "currentSubscription"])
  },
  watch: {},
  async mounted() {
    if (this.currentUser.role !== "super_admin" && !this.currentUser.is_owner) {
      return this.$router.push({ name: "Clients" });
    }

    this.pageLoading = true;
    await this.getCurrentSubscription();
    this.pageLoading = false;
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) app.scroll({ top: 0, left: 0 });
  },
  methods: {
    ...mapActions(["getCurrentSubscription"]),
    displayDate,
    displayPrice,
    priceFormats(price = 0) {
      const settings = this.currentSubscription.currency_settings;
      return this.displayPrice({ settings, price });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/billing/Billing.vue